export default __webpack_public_path__ + "static/media/fr_FR.448f5a77.svg";